// extracted by mini-css-extract-plugin
export default {"wrapper":"BooksList_wrapper__bBN5q"};